import { get, post } from ".";

export const getProjects = async (userId, callback, errorCallback) => {
  get(
    `project/getProjects?userId=${userId}`,
    (data) => {
      callback(data);
    },
    errorCallback
  );
};

export const getMembers = async (projectId, callback, errorCallback) => {
  get(
    `project/${projectId}/getMembers`,
    (members) => {
      callback(members);
    },
    errorCallback
  );
};

export const createProject = (project, resolve, reject) => {
  post(
    "project/addProject",
    project,
    (data) => {
      resolve(data);
    },
    (error) => {
      reject(error);
    }
  );
};

export const editProject = (project, resolve, reject) => {
  post(
    "project/editProject",
    project,
    (data) => {
      resolve(data);
    },
    (error) => {
      reject(error);
    }
  );
};
